import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-simuler-un-remboursement',
  templateUrl: './simuler-un-remboursement.component.html',
  styleUrls: ['./simuler-un-remboursement.component.scss']
})
export class SimulerUnRemboursementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
